module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAQAAAD8x0bcAAABCUlEQVQoFXWRUWvCMBDHY5UOJhRxMNDpW586H4QqZQNLmv/FMfBVfGthCCIM6yxjPuzDL63WNdrcQXJ3+V3uLmFMlwZv5dv7nX9/Us/Wj0dRTMfIV7YlPumr0F9kFyJwxBoJd5fNal70TN/i5+zwjtjLyVVhhSCT/RKysJHjOuT1kbfOEKZY1SOqRgnRdtarR/Jx6EOt8zYORqQUPkCi+e4Nwlg4pLjqv3TxoN3rq+cNHKTMKMsmHVkjn2731jVB3I1OdUSIhQlSvzAqDM9Gyt06RE7EuihWOH1kt5gci33gVALiCSkW/73NelhhwztXeZ6tetshpRgJDrTFlFmGRgMnHPLBvK1H/wCW8zdcELx6SwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/common/img/share.png
// module id = 67
// module chunks = 6 11 12